import React from "react";
import { useTranslation } from "react-i18next";

/** Site institucional Br Domínio — crédito do painel/login (LAC-044). */
export const BRDOMINIO_URL =
  process.env.REACT_APP_BRDOMINIO_URL?.replace(/\/$/, "") ||
  "https://brdominio.com.br";

type BrandCreditProps = {
  className?: string;
  muted?: boolean;
};

/**
 * “Desenvolvido por Br Domínio” com link + i18n — telas de auth (ParticlesAuth).
 * Shell tenant/SA não usa footer (só conteúdo + padding liberado no custom.scss).
 */
const BrandCredit = ({ className = "", muted = true }: BrandCreditProps) => {
  const { t } = useTranslation();
  const textClass = muted ? "text-muted" : "";

  return (
    <span className={className}>
      {t("brand.developedByPrefix")}{" "}
      <a
        href={BRDOMINIO_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={textClass}
      >
        {t("brand.brDominio")}
      </a>
    </span>
  );
};

export default BrandCredit;
